var moment = require('moment')
require('sorttable/sorttable.js')

var submissions = []
var count = 0

$('.spin-table').show()
$.get('/api/sales-receipts/history', function (data) {
  var rows = ''
  submissions = data.rows
  count = data.count

  for (var i = 0; i < submissions.length; i++) {
    var submission = submissions[i]
    var userName = submission.User ? (submission.User.first_name + ' ' + submission.User.last_name) : 'Unknown User'

    rows += '<tr class="history-row" data-toggle="modal" data-target="#history-modal" data="' + i + '">' +
      '<td>' + 'Sales Receipts' + '</td>' +
      '<td>' + userName + '</td>' +
      '<td>' + moment(submission.createdAt).format('YYYY/MM/DD hh:mm:ss') + '</td>' +
      '<td>' + moment(submission.updatedAt).format('YYYY/MM/DD hh:mm:ss') + '</td>' +
      '</tr>'
  }

  $('.history-row').remove()
  $('.spin-table').hide()
  $('#history-tbody').append(rows)

  $('.history-row').click(function () {
    selectHistory($(this).attr('data'))
  })
})

var selectHistory = function (index) {
  $('#history-info-form .title').text('Sales Receipts Information')
  $('#input pre').html(JSON.stringify(submissions[index].input, null, 2))
  $('#submission pre').html(JSON.stringify(submissions[index].submission, null, 2))
  $('#response pre').html(JSON.stringify(submissions[index].response, null, 2))
  $('.tabcontent.defalut').show();
}

$('.tablinks').click(function (e) {
  e.preventDefault()
  let tabName = $(this).attr('data')
  $('.tabcontent').hide()
  $('.tablinks').removeClass('active')
  $('#' + tabName).show()
  $(this).addClass('active')
})
